export const getAssetSearchTerm = state => {
    return state.assetSearch.searchTerm;
}

export const getAssetSearchSelectedTags = state => state.assetSearch.selectedTags;



// WEBPACK FOOTER //
// ./src/selectors/searchSelectors.js